import numeral from 'numeral';

// load a locale
numeral.register('locale', 'es', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'mi',
    billion: 'b',
    trillion: 't',
  },
  currency: {
    symbol: '$',
  },
});
